import React, { useState } from 'react';

function FilterModal({ onFilter }) {
  const [statuses, setStatuses] = useState(['NEW', 'PROCESS', 'DECLINED', 'DONE']);
  const [date, setDate] = useState('');
  const [bookingCode, setBookingCode] = useState('');

  const handleCheck = (val) => {
    const existingIndex = statuses.findIndex((item) => item === val);
    const newArray = [...statuses];
    if (existingIndex >= 0) {
      newArray.splice(existingIndex, 1);
      setStatuses(newArray);
    } else {
      newArray.push(val);
      setStatuses(newArray);
    }
  };

  const filterData = () => {
    onFilter(bookingCode, statuses, date);
    document.getElementById('closeModalFilter').click();
  };

  return (
    <div className="modal" tabIndex="-1" id="exampleModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Filter Data</h5>
            <button
              id="closeModalFilter"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label className="fw-600 mb-10">Kode Booking</label>
              <input
                type="text"
                onChange={(e) => setBookingCode(e.target.value)}
                className="form-control"
                value={bookingCode}
              />
            </div>
            <div className="form-group">
              <label className="fw-600 mb-10">Tanggal Pengajuan</label>
              <input
                type="date"
                onChange={(e) => setDate(e.target.value)}
                className="form-control"
                value={date}
              />
            </div>
            <label htmlFor="checkboxes" className="fw-600 mb-10">
              Status :
            </label>
            <div className="form-checkbox d-flex items-center mb-10 ml-10">
              <input
                type="checkbox"
                onChange={() => handleCheck('NEW')}
                checked={statuses.includes('NEW')}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">Dalam Review</div>
            </div>
            <div className="form-checkbox d-flex items-center mb-10 ml-10">
              <input
                type="checkbox"
                onChange={() => handleCheck('PROCESS')}
                checked={statuses.includes('PROCESS')}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">Diproses</div>
            </div>
            <div className="form-checkbox d-flex items-center mb-10 ml-10">
              <input
                type="checkbox"
                onChange={() => handleCheck('DECLINED')}
                checked={statuses.includes('DECLINED')}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">Ditolak</div>
            </div>
            <div className="form-checkbox d-flex items-center mb-10 ml-10">
              <input
                type="checkbox"
                onChange={() => handleCheck('DONE')}
                checked={statuses.includes('DONE')}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">Selesai</div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={filterData}
              type="button"
              className="btn btn-primary bg-blue-1 rounded-1">
              Filter Data
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterModal;
